import { useOrgInfo } from '../../../global/auth/use-org-info/use-org-info';
import { useIsPageHidden } from '../../../global/auth/use-hidden-pages/use-hidden-pages';
import { HideablePageId } from '../../../global/auth/use-hidden-pages/hideable-pages';
import { ActivityTabValue } from './ActivityTypes';

const EXPLORE_TAB_PAGE_IDS: Record<ActivityTabValue, HideablePageId> = {
  programs: 'explore-tab.programs',
  all: 'explore-tab.activities',
  mine: 'explore-tab.my-rosters',
  roles: 'explore-tab.roles',
};

const EXPLORE_TAB_ORDER: ActivityTabValue[] = ['programs', 'all', 'mine', 'roles'];

export const useVisibleExploreTabs = (): ActivityTabValue[] => {
  const org = useOrgInfo();
  const isPageHidden = useIsPageHidden();
  const rolesTabEnabled = org?.allowGeneralRoleApplications ?? false;

  return EXPLORE_TAB_ORDER.filter(
    (tab) => (tab !== 'roles' || rolesTabEnabled) && !isPageHidden(EXPLORE_TAB_PAGE_IDS[tab])
  );
};
